import { render } from "./menuView.vue?vue&type=template&id=addf9a42&scoped=true"
import script from "./menuView.vue?vue&type=script&lang=js"
export * from "./menuView.vue?vue&type=script&lang=js"

import "./menuView.vue?vue&type=style&index=0&id=addf9a42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-addf9a42"]])

export default __exports__